export const OUTPUT_IDENTIFIER = '##';

export const OUTPUT_TOKEN_CLASS = 'output-token';
export const OUTPUT_TOKEN_DELETE_CLASS = 'output-token-delete';
export const OUTPUT_TOKEN_FIXED_CLASS = 'output-token-fixed';
export const OUTPUT_TOKEN_CURRENT_CLASS = 'output-token-current';
export const OUTPUT_TOKEN_START_TAG = '<span class="' + OUTPUT_TOKEN_CLASS + ' ' +  OUTPUT_TOKEN_CURRENT_CLASS + '">';
export const OUTPUT_TOKEN_END_TAG = '</span>';
export const OUTPUT_ID_ATTRIBUTE = 'output-id';
export const ZERO_WIDTH_SPACE = '\u200B';
export const OUTPUT_DROPDOWN_DEFAULT = {
	index: 0,
	key: '',
	text: '-'
};


// WEBPACK FOOTER //
// ./source/ts/constants/outputs.ts